module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/ponderosa_bw-p-130x130q80-6af3693fd99324b1e68cc866b01efb22.jpg";